import React, { useState } from 'react';
import { CopyIcon, CheckIcon } from 'lucide-react';
import PageHeader from '../components/PageHeader';
import { useNavigate } from 'react-router-dom';
const SyncPage: React.FC = () => {
  const navigate = useNavigate();
  const [syncCode, setSyncCode] = useState('');
  const [generatedCode, setGeneratedCode] = useState('');
  const [copied, setCopied] = useState(false);
  const generateCode = () => {
    // Generate a 12-character code (4-4-4 format)
    const part1 = Math.random().toString(36).substring(2, 6).toUpperCase();
    const part2 = Math.random().toString(36).substring(2, 6).toUpperCase();
    const part3 = Math.random().toString(36).substring(2, 6).toUpperCase();
    const newCode = `${part1} ${part2} ${part3}`;
    setGeneratedCode(newCode);
  };
  const copyToClipboard = () => {
    navigator.clipboard.writeText(generatedCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  const connectWithCode = () => {
    // In a real app, this would connect to another device using the entered code
    // For the demo, we'll navigate to the demo sync mode
    navigate('/demo-sync');
  };
  // Format the input as the user types (4-4-4 format)
  const handleSyncCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    // Add spaces after every 4 characters
    if (value.length > 4) {
      value = value.slice(0, 4) + ' ' + value.slice(4);
    }
    if (value.length > 9) {
      value = value.slice(0, 9) + ' ' + value.slice(9);
    }
    // Limit to 12 chars plus 2 spaces
    if (value.length <= 14) {
      setSyncCode(value);
    }
  };
  return <div className="flex-1 flex flex-col" data-id="element-337">
      <PageHeader title="Sync Devices" data-id="element-338" />
      <div className="flex-1 p-6 flex flex-col items-center justify-center" data-id="element-339">
        <div className="w-full max-w-md space-y-8" data-id="element-340">
          <div className="bg-gray-900 p-6 rounded-lg" data-id="element-341">
            <h2 className="text-lg font-semibold mb-4" data-id="element-342">Generate Code</h2>
            <p className="text-gray-400 mb-4" data-id="element-343">
              Generate a code on this device and enter it on another device to
              sync them. This device will act as the controller for all other
              devices.
            </p>
            {generatedCode ? <div className="mb-4" data-id="element-344">
                <div className="bg-gray-800 p-4 rounded flex justify-between items-center" data-id="element-345">
                  <span className="text-xl font-mono" data-id="element-346">{generatedCode}</span>
                  <button onClick={copyToClipboard} className="text-gray-400 hover:text-white" data-id="element-347">
                    {copied ? <CheckIcon size={20} data-id="element-348" /> : <CopyIcon size={20} data-id="element-349" />}
                  </button>
                </div>
                <p className="text-sm text-gray-500 mt-2" data-id="element-350">
                  This code will expire in 10 minutes
                </p>
              </div> : <button onClick={generateCode} className="w-full bg-blue-900 text-white py-3 rounded-lg" data-id="element-351">
                Generate New Code
              </button>}
          </div>
          <div className="bg-gray-900 p-6 rounded-lg" data-id="element-352">
            <h2 className="text-lg font-semibold mb-4" data-id="element-353">Enter Code</h2>
            <p className="text-gray-400 mb-4" data-id="element-354">
              Enter a code generated on another device to sync with it.
            </p>
            <input type="text" value={syncCode} onChange={handleSyncCodeChange} placeholder="XXXX XXXX XXXX" className="w-full bg-gray-800 border border-gray-700 p-3 rounded-lg mb-4 text-center text-xl font-mono" data-id="element-355" />
            <button onClick={connectWithCode} disabled={syncCode.replace(/\s/g, '').length < 12} className={`w-full py-3 rounded-lg ${syncCode.replace(/\s/g, '').length === 12 ? 'bg-blue-900 text-white' : 'bg-gray-800 text-gray-500 cursor-not-allowed'}`} data-id="element-356">
              Connect
            </button>
          </div>
        </div>
      </div>
    </div>;
};
export default SyncPage;